import { FC } from 'react';

import { Box, Tab, Tabs } from '@qwealth/qcore';
import { QTask, TASK_COMPLETED } from '@qwealth/qdata';
import { DocumentPreview } from '@qwealth/kyc';

import TransitionBox from 'components/Households/Common/QNotes/TransitionBox';
import ConversationFormSection from './ConversationFormSection';
import { ModalModeOptions, TASK_TAB_ATTACHMENTS, TASK_TAB_COMMENTS, TASK_TAB_QNOTES, TaskTabOptions } from 'data/models/Activity';
import { QTaskForm } from 'data/models/taskForm';
import QNotesSection from './QNotesSection';

interface Props {
  task: Partial<QTask>;
  formValues: QTaskForm;
  setIsTaskModalHidden?: React.Dispatch<React.SetStateAction<boolean>>;
  qNoteModalMode: ModalModeOptions;
  setQNoteModalMode: React.Dispatch<React.SetStateAction<ModalModeOptions>>;
  tabOption?: TaskTabOptions;
  selectedTab: TaskTabOptions;
  setSelectedTab: React.Dispatch<React.SetStateAction<TaskTabOptions>>;
  taskAttachmentsPath: string;
}

const CommentNoteAttachmentSection: FC<Props> = ({
  task,
  formValues,
  setIsTaskModalHidden,
  qNoteModalMode,
  setQNoteModalMode,
  selectedTab,
  setSelectedTab,
  taskAttachmentsPath,
}) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" overflow="hidden">
      <Tabs
        mb="large"
        onSelect={id => {
          setSelectedTab(id as TaskTabOptions);
        }}
        selectedTab={selectedTab}
      >
        <Tab id="Comments">{TASK_TAB_COMMENTS}</Tab>
        <Tab id="QNotes">{TASK_TAB_QNOTES}</Tab>
        <Tab id="Attachments">{TASK_TAB_ATTACHMENTS}</Tab>
      </Tabs>

      {selectedTab === TASK_TAB_COMMENTS && (
        <TransitionBox index={1} isVisible={true} width="100%" paddingLeft="large" paddingRight="large">
          <ConversationFormSection taskId={task?.id} setIsTaskModalHidden={setIsTaskModalHidden} />
        </TransitionBox>
      )}
      {selectedTab === TASK_TAB_QNOTES && (
        <TransitionBox index={2} isVisible={true} width="100%" paddingLeft="large" paddingRight="large">
          <QNotesSection
            householdId={task?.householdQID ?? ''}
            qNoteModalMode={qNoteModalMode}
            setQNoteModalMode={setQNoteModalMode}
            setIsTaskModalHidden={setIsTaskModalHidden}
            task={task}
          />
        </TransitionBox>
      )}
      {selectedTab === TASK_TAB_ATTACHMENTS && (
        <TransitionBox index={3} isVisible={true} width="100%" paddingLeft="large" paddingRight="large">
          <DocumentPreview
            path={taskAttachmentsPath}
            isFileDeletable={formValues.status !== TASK_COMPLETED}
            {...(formValues.isRecurring && {
              deleteConfirmationExtraInfo: (
                <Box>
                  <b>Note - </b>This file will be removed from all tasks related to this recurring task. Are you sure you want to proceed?
                </Box>
              ),
            })}
            setPreviousModalHidden={setIsTaskModalHidden}
            cardSize="default"
          />
        </TransitionBox>
      )}
    </Box>
  );
};

export default CommentNoteAttachmentSection;
